"use client";

import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

interface SideAnimationProps {
  slideTexts: string[];
}

export default function SideAnimation({ slideTexts }: SideAnimationProps) {
  const [activeSection, setActiveSection] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSection((prev) => (prev + 1) % slideTexts.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [slideTexts.length]);

  return (
    <div className="relative h-[180px] md:h-full overflow-hidden">

      <div
        className="absolute inset-0 z-0"
      >
        <div
          className="w-full h-full  object-cover "
          style={{
            backgroundImage: "url('/images/table.png')",
            backgroundSize: "cover",
            backgroundPosition: "bottom"
          }}
        />
      </div>

      <div className="absolute inset-0 bg-gradient-to-t from-blue-900/50 via-blue-800/10 to-transparent z-10"></div>

      <div className="absolute bottom-0 md:bottom-10 xl:bottom-20 left-2 right-0 p-8 z-30">
        <div >
          <h3 className="font-black text-4xl md:text-5xl tracking-tight drop-shadow-lg text-white">
            SURFWAY
          </h3>

          <div className="h-10 relative overflow-hidden mt-1">
            <AnimatePresence mode="wait">
              <motion.p
                key={activeSection}
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: -20, opacity: 0 }}
                transition={{ duration: 0.5 }}
                className="text-md font-medium  text-white md:text-blue-100 drop-shadow-md absolute"
              >
                {slideTexts[activeSection]}
              </motion.p>
            </AnimatePresence>
          </div>

          <div className="flex space-x-1 mt-3">
            {slideTexts.map((_, idx) => (
              <motion.div
                key={idx}
                className={`h-1 rounded-full ${idx === activeSection ? 'w-6 bg-white' : 'w-2 bg-white/40'}`}
                animate={{ width: idx === activeSection ? 24 : 8 }}
                transition={{ duration: 0.3 }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
} 